import { Injectable } from '@angular/core';
import { CustomCategoryHierarchy, CustomCategorySeo } from '@catalog/const';
import { CategoryDetailsFacade } from '@catalog/data-access';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CategoryDetailsService {
  constructor(private categoryDetailsFacade: CategoryDetailsFacade) {}

  getSeo(): Observable<CustomCategorySeo | undefined> {
    return this.categoryDetailsFacade.getCategoryDetailsState().pipe(
      filter(({ error, success }) => Boolean(error || success)),
      map(({ value }) => value?.seo),
    );
  }

  getCategoryDetails(): Observable<CustomCategoryHierarchy | undefined> {
    return this.categoryDetailsFacade.getCategoryDetailsState().pipe(
      filter(({ error, success }) => Boolean(error || success)),
      map(({ value }) => value),
    );
  }

  getCategoryDetailsLoading(): Observable<boolean> {
    return this.categoryDetailsFacade
      .getCategoryDetailsState()
      .pipe(map(({ loading, error, success }) => loading || (!error && !success)));
  }
}
